{
    "chooseDevice": {
        "brand": "Brand",
        "category": "Category",
        "color": "Color",
        "cpu": "CPU",
        "deviceNotAccepted": "Unfortunately, this device is not accepted",
        "gpu": "Video card",
        "memory": "Storage",
        "model": "Model",
        "other": "Memory / Model / Year",
        "ram": "RAM",
        "subtitle": "Specify the model to find out the discount amount",
        "subtitleTradeIn": "Specify the model to find out the Trade in Amount",
        "title": "Which device do you want to donate?",
        "titleTradeIn": "Which device do you want to Trade In?"
    },
    "common": {
        "back": "Back",
        "close": "Close",
        "continue": "Continue",
        "error": "Something went wrong. Please try again.",
        "restart": "Restart"
    },
    "grades": {
        "A": "Excellent",
        "B": "Good",
        "C": "With traces of exploitation",
        "D": "With significant traces of exploitation",
        "E": "Critical",
        "Q": "Perfect"
    },
    "handedDevice": {
        "edit": "Change device",
        "title": "Your device",
        "valuation": "Preliminary estimate"
    },
    "leaveContacts": {
        "priceNote": "Prices are valid for 14 business days, and the final buyout price will be known only after a physical inspection.",
        "title": "Preliminary price"
    },
    "requestBuyoutOffer": {
        "companyName": "Company name",
        "consent": "I agree to the processing of my personal data in accordance with {link}",
        "consentLink": "the Law of Ukraine “On Personal Data Protection”",
        "email": "Email",
        "emailInvalid": "Enter a valid email",
        "firstName": "First name",
        "lastName": "Last name",
        "optional": "optional",
        "phone": "Phone",
        "phoneInvalid": "Enter the number with the country code, 9 to 15 digits",
        "subtitle": "Leave your contacts so that our manager can prepare a buyout offer for you",
        "title": "Find out how much all of your company's devices are worth"
    },
    "select": {
        "notFound": "Sorry. No matches were found."
    },
    "thanksForOrder": {
        "sendAnother": "Send another request",
        "text": "Our manager will calculate the value of your devices and contact you. Thank you for extending the life of technology! ☘️",
        "title": "Done! Your request has been sent."
    },
    "uploadDevicesList": {
        "chooseFile": "Choose a file",
        "downloadTemplate": "Download the device list template",
        "dropHere": "Drag the file here",
        "invalidFormat": "Only XLSX files are supported",
        "or": "or",
        "removeFile": "Remove file",
        "submit": "Get a buyout offer",
        "subtitle": "Upload a file with the list of devices in XLSX format or fill in the template",
        "title": "Upload the list of devices for evaluation"
    }
}
